/**
 * Copyright (c) 2021
 *
 * Privacy policy for the niroshpg.com website.
 * App-specific policies live as static files under /apps/<app>/.
 *
 * @author Nirosh Gunaratne <niroshpg@gmail.com>
 */

import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="legal">
      <h1>Privacy Policy &mdash; niroshpg.com</h1>
      <p className="legal__meta">
        Effective date: 30 August 2026
        <br />
        Owner: Nirosh Gunaratne
      </p>

      <p>
        This policy covers the niroshpg.com website. Individual applications
        published by Nirosh Gunaratne have their own privacy policies. Earthquake
        Monitor has one per platform, because the two apps are separate builds
        using different mapping and location services:{" "}
        <a href="/apps/earthquake-monitor/privacy">
          Android
        </a>{" "}
        and{" "}
        <a href="/apps/earthquake-monitor/privacy-ios.html">
          iOS
        </a>.
      </p>

      <h2>Summary</h2>
      <p>
        The website has no accounts, no advertising, and no analytics or
        third-party tracking. The only personal information it receives is what
        you choose to send through the contact form.
      </p>

      <h2>Contact form</h2>
      <p>
        If you use the contact form, the name, email address, and message you
        enter are sent to the site owner by email (via the EmailJS service) so
        that the owner can reply. This information is used only to respond to your
        enquiry and is not sold, shared for advertising, or used for marketing.
        EmailJS processes the submission in transit; see{" "}
        <a href="https://www.emailjs.com/legal/privacy-policy/">
          emailjs.com/legal/privacy-policy
        </a>.
      </p>

      <h2>Server logs</h2>
      <p>
        The site is hosted on AWS (Amplify Hosting / CloudFront). As with any web
        host, standard request logs may record information such as IP address,
        browser type, referring page, and timestamp. These logs are used only for
        operating and securing the site and are not linked to your identity.
      </p>

      <h2>Cookies and tracking</h2>
      <p>
        The site does not set advertising or analytics cookies and does not embed
        third-party trackers. Fonts are loaded from Google Fonts, which may log
        the request as described in Google&apos;s privacy policy.
      </p>

      <h2>Your choices</h2>
      <p>
        You can browse the site without providing any personal information. If you
        have sent a message and would like it deleted, contact the owner at the
        address below.
      </p>

      <h2>Children</h2>
      <p>
        The site is not directed at children and does not knowingly collect
        information from children under 13.
      </p>

      <h2>Changes</h2>
      <p>
        Updates to this policy will be posted on this page with a new effective
        date.
      </p>

      <h2>Contact</h2>
      <p>
        Nirosh Gunaratne &mdash;{" "}
        <a href="mailto:niroshpg@gmail.com">niroshpg@gmail.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
